import styled from 'styled-components';

const NavContainer = styled.div`
   padding: 7px 20px;
   background-color: transparent;
   display: flex;
   font-weight: 600;
   justify-content: space-between;
   align-items: center;
   flex-flow: row nowrap;
   max-width: 1200px;
   margin: 0 auto;

   @media only screen and (max-width: 650px) {
      font-size: 0.8em;
      font-weight: 400;
   }
`;

export default NavContainer;
